import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Formik } from "formik";
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import BOLFormatDoc from "./BOLFormatDoc";
import CountdownTimer from 'web/components/TimerCustom';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { TabContentWrapper, AccordionHeaderWrapper, AccordionDetailsWrapper } from "../orderStyled";
import * as moment from "moment";
import { Accordion, AccordionSummary, AccordionDetails, } from "@material-ui/core";
import AlertModal from 'web/components/AlertModal';
import EditIcon from "web/assets/images/edit-icon.png";
import SaveIcon from "web/assets/images/save-icon.png";
import NumberInput from "web/components/form-elements/NumberInput";
import TextInput from "web/components/form-elements/TextInput";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PickupDetailsModal from "../PopUpModals/PickupDetailsModal";
import PuUpdOrderQtyButton from 'web/assets/images/puUpdOrderQtyButton.png';
import CancelRescheduleModal from "../PopUpModals/CancelRescheduleModal";
import RetryPaymentModal from "../PopUpModals/RetryPaymentModal";
import { downloadFile } from "redux/actions/helper/downloadFile";
import { rescheduleAcceptDeclineApi, qtyUpdateApi, supRefNoUpdateApi, downloadInvoiceApi } from "redux/actions/myPickupOrders";
import ClaimRaiseResolveModal from "../PopUpModals/ClaimRaiseResolveModal";

const TabContentAccordionWebView = (nestedProps) => {
  const props = nestedProps.props
  const { pageData } = props
  const dispatch = useDispatch();
  let history = useHistory()
  const token = localStorage.getItem("token")
  const nowUTC = moment(new Date(Date.now() + new Date().getTimezoneOffset() * 60000))
  const [qtyEditList, setQtyEditList] = useState([])
  const [supRefNoEditList, setSupRefNoEditList] = useState([])
  const [pickupDetailsModalIsOpen, setPickupDetailsModalIsOpen] = useState(false)
  const [cancelOrRescheduleModalIsOpen, setCancelOrRescheduleModalIsOpen] = useState(false)
  const [claimResolveModalIsOpen, setClaimResolveModalIsOpen] = useState(false)
  const [retryPaymentModalIsOpen, setRetryPaymentModalIsOpen] = useState(false)
  const [claimRaiseResolveType, setClaimRaiseResolveType] = useState()
  const [selectedOrderDetails, setSelectedOrderDetails] = useState()
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [alertType, setAlertType] = useState('');

  const capitalizeFirstLetter = (input) => {
    if (input === 'PICKEDUP') return 'Picked Up'
    else if (input === 'CANCELLED') return 'Canceled'
    else if (input) return input[0].toUpperCase() + input.slice(1).toLowerCase();
  }

  const rescheduleAcceptDeclineFunction = async (data, responseType) => {
    let apiData = {
      orderId: data.orderId,
      rescheduleStatus: responseType,
      rescheduledBy: data.userType
    }
    let response = await dispatch(rescheduleAcceptDeclineApi(apiData, token));
    if (response?.success) {
      setAlertType('rescheduleAcceptDeclinesuccess')
      setModalContent(response?.data?.msg);
      setModal(!modal)
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(!modal);
      }
    }
  }

  const downloadBolFormatPdf = async (data) => {
    const blob = await pdf((
      <BOLFormatDoc
        pdfDocumentData={data}
      />
    )).toBlob();
    saveAs(blob, `BOL_${data.orderId}`);
  }

  const updQtyFunction = async (data, qtyVal) => {
    if (parseInt(qtyVal) < 1) {
      setModalContent('Quantity should be greater than 0.');
      setModal(!modal)
      return
    }
    let apiData = {
      orderId: data.orderId,
      qty: qtyVal
    }
    let response = await dispatch(qtyUpdateApi(apiData, token));
    if (response?.success) {
      let qtyTempEditList = JSON.parse(JSON.stringify(qtyEditList))
      let updQtyEditList = qtyTempEditList.filter(item => item !== data.orderId)
      setQtyEditList(JSON.parse(JSON.stringify(updQtyEditList)))
      setAlertType('updateSuccess')
      setModalContent(response?.data?.msg);
      setModal(!modal)
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(!modal);
      }
    }
  }

  const updSupRefNoFunction = async (data, supRefNo) => {
    let apiData = {
      orderId: data.orderId,
      supplierRefNumber: supRefNo
    }
    let response = await dispatch(supRefNoUpdateApi(apiData, token));
    if (response?.success) {
      let supRefNoTempEditList = JSON.parse(JSON.stringify(supRefNoEditList))
      let updSupRefEditList = supRefNoTempEditList.filter(item => item !== data.orderId)
      setSupRefNoEditList(JSON.parse(JSON.stringify(updSupRefEditList)))
      setAlertType('updateSuccess')
      setModalContent(response?.data?.msg);
      setModal(!modal)
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(!modal);
      }
    }
  }

  const downloadReceiptFunction = async (data) => {
    let invoiceId = data?.userType === 'BUYER' ? data?.invoiceDet?.buyerInvoiceId : data?.invoiceDet?.sellerInvoiceId
    if (invoiceId?.endsWith('.pdf')) invoiceId = invoiceId.slice(0, -4)
    let response = await dispatch(downloadInvoiceApi(invoiceId, token));
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Receipt_${data?.orderId}.pdf`);
    document.body.appendChild(link);
    link.click();
  }

  const downloadPODFunction = (data) => {
    let res = data?.pickedupDetails?.uploadedDocs.map(val => dispatch(downloadFile(val.fileName)))
  }

  const deliverOrder = data => {
    if (data?.orderStatus === 'ASSIGNED') {
      setSelectedOrderDetails(data)
      setPickupDetailsModalIsOpen(true)
    }
  }

  const rescheduledButtonRender = data => {
    return (
      <button className='res-button-style' onClick={(e) => {
        e.stopPropagation();
        setSelectedOrderDetails(data);
        setCancelOrRescheduleModalIsOpen(true);
      }}>
        Reschedule / Cancel
      </button>
    )
  }

  const pickupOrderButtonRender = data => {
    return (
      <button className='res-button-style' onClick={(e) => {
        e.stopPropagation();
        setSelectedOrderDetails(data)
        setPickupDetailsModalIsOpen(true)
      }}>
        Upload Sort Form
      </button>
    )
  }

  const downloadPuFormButtonRender = data => {
    return (
      <button className='res-button-style' onClick={(e) => {
        e.stopPropagation();
        downloadBolFormatPdf(data);
      }}>
        Download Sort Form
      </button>
    )
  }

  const raiseClaimButtonRender = data => {
    return (
      <div className="raise-raise-button-style">
        <button onClick={() => {
          setSelectedOrderDetails(data)
          setClaimRaiseResolveType('raise')
          setClaimResolveModalIsOpen(true)
        }}>Raise Claim</button>
      </div>
    )
  }

  const downloadPickedupPuFormButtonRender = data => {
    return (
      <button className="receipt-style" onClick={(e) => {
        e.stopPropagation();
        downloadPODFunction(data)
      }}>
        Print Sort POD
      </button>
    )
  }

  const downloadReceiptButtonRender = data => {
    return (
      <button className="receipt-style" onClick={(e) => {
        e.stopPropagation();
        downloadReceiptFunction(data)
      }}>
        Invoice
      </button>
    )
  }

  const claimActionButtonsRender = data => {
    return (
      <div className="claim-buttons-style" style={{ minWidth: '320px' }}>
        <button className="accept" onClick={(e) => {
          e.stopPropagation();
          setSelectedOrderDetails(data)
          setClaimRaiseResolveType('accept')
          setClaimResolveModalIsOpen(true)
        }}>Accept</button>
        <button className="reject" onClick={(e) => {
          e.stopPropagation();
          setSelectedOrderDetails(data)
          setClaimRaiseResolveType('decline')
          setClaimResolveModalIsOpen(true)
        }}>Decline</button>
      </div>
    )
  }

  return (
    <>
      <TabContentWrapper>
        <div style={{ marginBottom: '20px', padding: '0 10px' }}>
          {pageData?.map((data, index) => {
            return (
              <div className="accordion-tab-content-web-view">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <AccordionHeaderWrapper>
                      <p style={{ color: '#0A5587' }}>{data.orderId}</p>
                      <p>{data.poNumber}</p>
                      <p>{`(${data.pickupLocation?.city}, ${stateConvert(data.pickupLocation?.state) || data.pickupLocation?.state})`}</p>
                      <p style={{ color: '#0A5587' }}>{moment(data.pickupDate).format('MM/DD/YYYY')}</p>
                      <p className={`order-status-${data.orderStatus}`}>{capitalizeFirstLetter(data.orderStatus)}</p>

                      {/* buttons conditinal rendering based on tabs */}
                      {data?.orderStatus === 'ASSIGNED' &&
                        <div className="assigned-header-style" style={{ minWidth: '320px' }}>
                          {data?.userType === 'BUYER' && downloadPuFormButtonRender(data)}
                          {data?.userType === 'SELLER' ? rescheduledButtonRender(data) : pickupOrderButtonRender(data)}

                        </div>
                      }
                      {(data?.orderStatus === 'PICKEDUP' || data?.orderStatus === 'HOLD') &&
                        <div className="assigned-header-style" style={{ minWidth: '320px', justifyContent: 'end' }}>
                          {(data?.userType === 'SELLER' && data?.claimPeriodEndDate && !moment(data?.claimPeriodEndDate).isBefore(nowUTC)) && raiseClaimButtonRender(data)}
                          {downloadPickedupPuFormButtonRender(data)}
                        </div>
                      }
                      {(data?.orderStatus === 'COMPLETE') &&
                        <div className="assigned-header-style" style={{ minWidth: '320px' }}>
                          {data?.invoiceDet && downloadReceiptButtonRender(data)}
                          {downloadPickedupPuFormButtonRender(data)}
                        </div>
                      }
                      {data?.orderStatus === 'CLAIM' &&
                        (data?.userType === 'SELLER' ? claimActionButtonsRender(data) : <div style={{ minWidth: props?.pageTabName === "all" ? '320px' : 0 }}></div>)
                      }
                      {((data?.orderStatus === 'CANCELLED' && props?.pageTabName === "all") || data?.orderStatus === 'RESCHEDULED') &&
                        <div style={{ minWidth: '320px' }}></div>
                      }
                    </AccordionHeaderWrapper>
                  </AccordionSummary>
                  <AccordionDetails>
                    <AccordionDetailsWrapper>
                      <div className="main-div">
                        <p>Order ID:</p>
                        <span>{data.orderId}</span>
                      </div>
                      <div className="main-div">
                        <p>Purchase Order:</p>
                        <span>{data.poNumber}</span>
                      </div>
                      {(data?.userType === 'BUYER' && ['scheduled', 'pickedup', 'complete', 'claimed'].includes(props?.pageTabName)) ?
                        <div className="main-div">
                          <p>Supplier Ref #:</p>
                          <Formik initialValues={{ [`supplierRefNo_${data.orderId}`]: data.supplierRefNumber }} key={data.orderId}>
                            {(formikProps) => {
                              const { setFieldValue, values } = formikProps;
                              return (
                                <div className="qty-style">
                                  <TextInput
                                    name={`supplierRefNo_${data.orderId}`}
                                    showErrorMessages={true}
                                    placeholder=""
                                    decimalScale={0}
                                    maxLength={20}
                                    disabled={!supRefNoEditList?.includes(data.orderId)}
                                    changeHandler={(val) => setFieldValue('supplierRefNo', val)}
                                  />
                                  {supRefNoEditList?.includes(data.orderId) ?
                                    <img className="save-image" src={SaveIcon} alt="save icon" onClick={() => updSupRefNoFunction(data, values.supplierRefNo)} />
                                    :
                                    <img src={EditIcon} alt="edit icon" onClick={() => {
                                      let supRefNoTempEditList = JSON.parse(JSON.stringify(supRefNoEditList))
                                      supRefNoTempEditList.push(data.orderId)
                                      setSupRefNoEditList(JSON.parse(JSON.stringify(supRefNoTempEditList)))
                                    }} />
                                  }
                                </div>
                              )
                            }}
                          </Formik>
                        </div>
                        :
                        (data?.userType === 'SELLER' && ['scheduled', 'pickedup', 'complete', 'claimed'].includes(props?.pageTabName)) &&
                        <div className="main-div">
                          <p>Supplier Ref #:</p>
                          <span>{data.supplierRefNumber || 'NA'}</span>
                        </div>
                      }
                      <hr />
                      <div className="main-div">
                        <p>Estimated Order Quantity:</p>
                        {(data?.userType === 'SELLER' && (data?.orderStatus === 'ASSIGNED' || data?.orderStatus === 'RESCHEDULED')) ?
                          <Formik initialValues={{ [`estQty_${data.orderId}`]: data.quantity }} key={data.orderId}>
                            {(formikProps) => {
                              const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
                              return (
                                <div className="qty-style">
                                  <NumberInput
                                    name={`estQty_${data.orderId}`}
                                    showErrorMessages={true}
                                    placeholder=""
                                    decimalScale={0}
                                    maxLength={4}
                                    disabled={!qtyEditList?.includes(data.orderId)}
                                    onChangeHandler={(val) => setFieldValue('estQty', val)}
                                  />
                                  {qtyEditList?.includes(data.orderId) ?
                                    <img className="save-image" src={SaveIcon} alt="save icon" onClick={() => updQtyFunction(data, values.estQty)} />
                                    :
                                    <img src={EditIcon} alt="edit icon" onClick={() => {
                                      let qtyTempEditList = JSON.parse(JSON.stringify(qtyEditList))
                                      qtyTempEditList.push(data.orderId)
                                      setQtyEditList(JSON.parse(JSON.stringify(qtyTempEditList)))
                                    }} />
                                  }
                                </div>
                              )
                            }}
                          </Formik>
                          :
                          <span>{data.quantity}</span>
                        }
                      </div>
                      {data?.orderStatus === 'CLAIM' &&
                        <div className="main-div">
                          <p>Recorded Quantity:</p>
                          <span>{data.pickedupDetails?.palletList?.reduce((acc, data) => acc + data.qty, 0)}</span>
                        </div>
                      }
                      {data?.userType === 'SELLER' &&
                        <div className="main-div">
                          <p>PT+ Reference Number:</p>
                          <span>{data.ptplusRefNumber}</span>
                        </div>
                      }
                      <div className="main-div">
                        <p>Requested Pickup Window:</p>
                        {data?.rescheduledDetails?.rescheduleList ?
                          <span>{moment(data?.rescheduledDetails?.oldRequestPickupDate).format('MM/DD/YYYY')} {data?.rescheduledDetails?.oldPickupStartTime} - {data?.rescheduledDetails?.oldPickupEndTime}</span> :
                          <span>{moment(data.pickupDate).format('MM/DD/YYYY')} {data.pickupAppointmentStartTime} - {data.pickupAppointmentEndTime}</span>
                        }
                      </div>
                      {(data?.orderStatus === 'ASSIGNED' && data?.rescheduledDetails?.rescheduleList) &&
                        <div className="main-div">
                          <p>Requested Reschedule Pickup Window:</p>
                          <span>{moment(data?.rescheduledDetails?.rescheduleList[0]?.rescheduleDate).format('MM/DD/YYYY')} {data?.rescheduledDetails?.rescheduleList[0]?.pickupAppointmentStartTime} - {data?.rescheduledDetails?.rescheduleList[0]?.pickupAppointmentEndTime}</span>
                        </div>
                      }
                      {(data?.orderStatus === 'CLAIM' || data?.orderStatus === 'PICKEDUP' || data?.orderStatus === 'COMPLETE' || data?.orderStatus === 'HOLD') && (
                        <div className="main-div">
                          <p>Actual Pickup Date:</p>
                          <span>{moment(data.pickedupDetails?.actualPickedupDate).format('MM/DD/YYYY')}</span>
                        </div>
                      )}
                      {(data?.orderStatus === 'COMPLETE') && (
                        <div className="main-div">
                          <p>Payment Initiated Date:</p>
                          <span>{moment(data.initiatePaymentDate).format('MM/DD/YYYY')}</span>
                        </div>
                      )}
                      <hr />
                      <div className="main-div">
                        <p>Pickup Address:</p>
                        <div style={{ display: 'grid' }}>
                          <span style={{ fontFamily: 'latobold' }}>{data.pickupLocation?.locationName}</span>
                          <span>{data.pickupLocation?.address1}</span>
                          <span>{data.pickupLocation?.city}, {stateConvert(data.pickupLocation?.state) || data.pickupLocation?.state} {data.pickupLocation?.zipCode}</span>
                        </div>
                      </div>
                      <div className="main-div">
                        <p>Equipment:</p>
                        <span>{data.loadingRequirement === 'DROP_TRAILER' ? 'Drop Trailer' : data.loadingRequirement === 'LIVE_LOAD' ? 'Live Load' : 'NA'}</span>
                      </div>
                      {(data?.sellerClaimRejected && data?.orderStatus === 'ASSIGNED' && data?.userType === 'BUYER') &&
                        <>
                          <p style={{ color: 'red', margin: '15px 0px 15px 0px' }}>The original uploaded form was rejected by a PT+ admin. Please review the rejection comments below, and re-upload the pickup sort form to complete the pickup.</p>
                          <div className="main-div">
                            <p>Rejection Comments:</p>
                            <span>{data?.claimRejectNote}</span>
                          </div>
                        </>
                      }
                      {((data?.userType === 'BUYER' && data?.orderStatus === 'ASSIGNED') || data?.orderStatus === 'PICKEDUP') &&
                        <div className="tracking-details">
                          <ul className="delivery-timeline">
                            <>
                              <li className="ordered">
                                <div className="d-icon" style={data?.orderStatus === 'PICKEDUP' ? { color: 'black' } : { color: 'inherit' }}><span>ORDER</span></div>
                              </li>
                              <li className={data?.orderStatus === 'ASSIGNED' ? "shipping pending" : "accepted pending"}>
                                {data?.orderStatus === 'ASSIGNED' && <img
                                  onClick={() => deliverOrder(data)}
                                  className="down-arrow" src={PuUpdOrderQtyButton} alt="Pallets" />}
                                <div
                                  onClick={() => deliverOrder(data)}
                                  className="d-icon" style={data?.orderStatus === 'PICKEDUP' ? { color: 'black' } : { color: 'inherit' }}>Complete Pickup</div>
                              </li>
                              <li className={data?.orderStatus === 'ASSIGNED' ? "shipping pending" : "delivered active"}>
                                <div className="d-icon" style={data?.orderStatus === 'PICKEDUP' ? { color: 'black' } : { color: 'inherit' }}>Pickup Form Completed</div>
                              </li>
                            </>
                          </ul>
                        </div>
                      }
                      <div className="pickup-orders-button-wrapper">
                        <div>
                          <div className="resche-button-wrapper">
                            {data?.orderStatus === 'ASSIGNED' &&
                              <button className='res-button-style' onClick={() => {
                                setSelectedOrderDetails(data)
                                setCancelOrRescheduleModalIsOpen(true)
                              }}>Reschedule / Cancel</button>
                            }
                            {(data?.userType === 'BUYER' && data?.orderStatus === 'ASSIGNED') && <button className='res-button-style' onClick={(e) => downloadBolFormatPdf(data)}>Download Sort Form</button>}
                          </div>
                          {(data?.orderStatus === 'RESCHEDULED' && data?.rescheduledDetails?.rescheduleList) &&
                            <div className="rescheduled-order-action-style">
                              {(data?.userType === data?.rescheduledDetails?.rescheduleList[0]?.rescheduledBy) ? (<>
                                <p>Reschedule order request has been sent.</p>
                              </>) : (<>
                                <p>The order has been asked to be rescheduled for {moment(data?.rescheduledDetails?.rescheduleList[0]?.rescheduleDate).format('MM/DD/YYYY')} {data?.rescheduledDetails?.rescheduleList[0]?.pickupAppointmentStartTime}-{data?.rescheduledDetails?.rescheduleList[0]?.pickupAppointmentEndTime}?</p>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                  <button className="accept" onClick={() => rescheduleAcceptDeclineFunction(data, 'ACCEPTED')}>Accept</button>
                                  <button className="reject" onClick={() => rescheduleAcceptDeclineFunction(data, 'REJECTED')}>Decline</button>
                                </div>
                              </>)}
                            </div>
                          }
                          {(data?.userType === 'SELLER' && data?.orderStatus === 'PICKEDUP' && data?.claimPeriodEndDate && !moment(data?.claimPeriodEndDate).isBefore(nowUTC)) &&
                            (<div className="raise-raise-button-style">
                              <button onClick={() => {
                                setSelectedOrderDetails(data)
                                setClaimRaiseResolveType('raise')
                                setClaimResolveModalIsOpen(true)
                              }}>Raise Claim</button>
                              <div className="timer-class"><CountdownTimer timerEnd={data?.claimPeriodEndDate} difCompareTime={'utc'} /></div>
                            </div>)
                          }
                          <div className="claim-buttons-style">
                            {(data?.orderStatus === 'CLAIM' && data?.userType === 'SELLER') && (
                              <>
                                <button className="accept" onClick={() => {
                                  setSelectedOrderDetails(data)
                                  setClaimRaiseResolveType('accept')
                                  setClaimResolveModalIsOpen(true)
                                }}>Accept</button>
                                <button className="reject" onClick={() => {
                                  setSelectedOrderDetails(data)
                                  setClaimRaiseResolveType('decline')
                                  setClaimResolveModalIsOpen(true)
                                }}>Decline</button>
                              </>
                            )}
                          </div>
                          {(data?.orderStatus === 'HOLD' && data?.userType === 'BUYER') &&
                            <div className="retry-payment-class"><button onClick={() => {
                              setSelectedOrderDetails(data)
                              setRetryPaymentModalIsOpen(true)
                            }}>Retry Payment</button></div>
                          }
                          {(data?.orderStatus === 'COMPLETE' && data?.invoiceDet) && (
                            <button className="receipt-style" onClick={() => downloadReceiptFunction(data)}>Print Invoice</button>
                          )}
                        </div>
                        <div>
                          {(data?.orderStatus === 'CLAIM' || data?.orderStatus === 'PICKEDUP' || data?.orderStatus === 'COMPLETE' || data?.orderStatus === 'HOLD') &&
                            <div style={{ display: 'flex', justifyContent: 'end' }}><button className="receipt-style" onClick={() => downloadPODFunction(data)}>Print Sort POD</button></div>
                          }
                        </div>
                      </div>
                    </AccordionDetailsWrapper>
                  </AccordionDetails>
                </Accordion>
              </div>
            )
          })}
        </div>
      </TabContentWrapper>
      {pickupDetailsModalIsOpen &&
        <PickupDetailsModal
          closeModal={() => setPickupDetailsModalIsOpen(false)}
          modalData={selectedOrderDetails}
          pickedupSuccessCallBack={() => props.pickedUpsuccessCallBack()}
          claimRaisedSuccessCallBack={() => props.claimRaisedSuccessCallBack()}
        />
      }
      {claimResolveModalIsOpen &&
        <ClaimRaiseResolveModal
          closeModal={() => setClaimResolveModalIsOpen(false)}
          modalData={selectedOrderDetails}
          claimRaiseResolveType={claimRaiseResolveType}
          claimDeclineSuccessCallBack={() => props.claimDeclineSuccessCallBack()}
          claimAcceptSuccessCallBack={() => props.claimAcceptSuccessCallBack()}
          claimRaiseSuccessCallBack={() => props.claimRaiseFromPickedUpSuccessCallBack()}
        />
      }
      {cancelOrRescheduleModalIsOpen &&
        <CancelRescheduleModal
          closeModal={() => setCancelOrRescheduleModalIsOpen(false)}
          modalData={selectedOrderDetails}
          cancelRescheduleOrderSuccessCallback={(type) => {
            if (type === 'cancel') props.cancelOrdersuccesscallBack()
            else if (type === 'reschedule') props.rescheduleOrdersuccesscallBack()
          }}
        />
      }
      {retryPaymentModalIsOpen &&
        <RetryPaymentModal
          closeModal={() => setRetryPaymentModalIsOpen(false)}
          modalData={selectedOrderDetails}
          retryPaymentSuccessCallback={() => {
            props.retryPaymentSuccessCallback()
          }}
        />
      }
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=""
        content={modalContent}
        link={''}
        alertType={'success'}
        callBackAlert={() => {
          if (alertType === 'rescheduleAcceptDeclinesuccess') {
            props.rescheduleAcceptDeclinesuccesscallBack();
          } else if (alertType === 'updateSuccess') {
            props.updateSuccesscallBack();
          }
        }}
      />
    </>
  )
}

export default TabContentAccordionWebView;